import React from "react";
import { useTranslation } from "react-i18next";

// Contagem regressiva ao vivo com dígitos que rolam (dias · horas · min · seg).
// Cada dígito é um "rolo" de 0 a 9 que desliza para o valor atual; só transform anima.
const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

function Reel({ value }) {
  return (
    <span className="ghxpFlip__digit">
      <span className="ghxpFlip__reel" style={{ "--d": value }}>
        {DIGITS.map((digit) => (
          <span key={digit}>{digit}</span>
        ))}
      </span>
    </span>
  );
}

function Cell({ value, label }) {
  const digits = String(value).padStart(2, "0").split("");
  return (
    <span className="ghxpFlip__cell">
      <span className="ghxpFlip__value">
        {digits.map((digit, i) => (
          <Reel key={`${digits.length}-${i}`} value={Number(digit)} />
        ))}
      </span>
      <span className="ghxpFlip__label">{label}</span>
    </span>
  );
}

function GhxpCountdown({ countdown, className = "" }) {
  const { t } = useTranslation();
  if (countdown.over) return null;

  return (
    <div
      className={`ghxpFlip ${className}`}
      role="timer"
      aria-label={countdown.today ? t("ghxp_countdown_today") : t("ghxp_countdown", { count: countdown.days })}
    >
      {countdown.today ? (
        <span className="ghxpFlip__today">{t("ghxp_countdown_today")}</span>
      ) : (
        <Cell value={countdown.days} label={t("ghxp_cd_days")} />
      )}
      <Cell value={countdown.hours} label={t("ghxp_cd_hours")} />
      <Cell value={countdown.minutes} label={t("ghxp_cd_minutes")} />
      <Cell value={countdown.seconds} label={t("ghxp_cd_seconds")} />
    </div>
  );
}

export default GhxpCountdown;
